<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useDataCollectionStore } from "@/stores/dataCollection";

  const uiStore = useUiStore();
  const dataCollectionStore = useDataCollectionStore();
  const emit = defineEmits(['refresh', 'refreshSitesArr']);
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  let id = ref(null);
  let name = ref(null);
  let description = ref(null);
  // let status = ref(null);
  // let statusOptions = ref([
  //   'Active',
  //   'Testing',
  //   'Disabled',
  // ]);
  let isSubmitted = ref(false);

  const onSubmit = async () => {
    isSubmitted.value = true;
    
    const data = { 
      id : id.value, 
      name: name.value,
      description: description.value,
      // status: status.value.charAt(0).toLowerCase() + status.value.slice(1),
      company_id 
    };
    dataCollectionStore.editDataSource(data).then(() => {
      emit('refresh');
      resetStoreData();
    }).catch(() => {
    });
  }

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'edit_data_collection'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
      description.value = getModalInfo.value.description;
      // status.value = getModalInfo.value.status.charAt(0).toUpperCase() + getModalInfo.value.status.slice(1);
    }
    
  });

</script>
<template>
  <DModal v-if="getModalAction === 'edit_data_source'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Collection </template>
    
    <template #body>
        
      <DInput :value="name" @input="name = $event.target.value" label="Collection Name" width="100%" />

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description" maxlength="65"
          id="collectionDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="collectionDescription">Description</label>
      </FloatLabel>

      <!-- <div class="relative"> 
        <span v-if="status" class="multiselect-title-span">Status</span>
        <VMultiselect v-model="status" :options="statusOptions" :disabled="!statusOptions.length" :loading="!statusOptions.length" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Status" />
      </div> -->

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!name || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Edit 
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>

  </DModal>
</template>
